<template>
    <div class="client-navigation-component" ref="root">
        <div :class="{ item: true, loading: loading }">
            <div :class="{ skeleton: loading }">{{ year }}年{{ month }}月度</div>
        </div>
        <div :class="{ item: true, loading: loading }">
            <div :class="{ skeleton: loading }">業務報告書</div>
            <div>
                <div :class="{ skeleton: loading }">
                    <a :href="reportUnreceivedUrl" class="nav-label">
                        未受領
                        <span :class="badge(reportUnreceivedCount)">
                            {{ reportUnreceivedCount }}
                        </span>
                    </a>
                </div>
            </div>
            <div>
                <div :class="{ skeleton: loading }">
                    <a :href="reportUnapprovedUrl" class="nav-label">
                        未検収
                        <span :class="badge(reportUnapprovedCount)">
                            {{ reportUnapprovedCount }}
                        </span>
                    </a>
                </div>
            </div>
        </div>
        <div :class="{ item: true, loading: loading }">
            <div :class="{ skeleton: loading }">請求書</div>
            <div>
                <div :class="{ skeleton: loading }">
                    <a :href="invoiceUnreceivedUrl" class="nav-label">
                        未受領
                        <span :class="badge(invoiceUnreceivedCount)">
                            {{ invoiceUnreceivedCount }}
                       </span>
                    </a>
                </div>
            </div>
            <div>
                <div :class="{ skeleton: loading }">
                    <a :href="invoiceUnapprovedUrl" class="nav-label">
                        未承認
                        <span :class="badge(invoiceUnapprovedCount)">
                            {{ invoiceUnapprovedCount }}
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.client-navigation-component {
    display: flex;
    padding: 12px 5px;
    width: 100%;
    margin: 0 auto;
    background: #009978;
    color: #fff;
    line-height: 1 !important;
    font-size: 0.8rem !important;

    .item {
        display: flex;
        align-items: center;
        padding: 4px 25px;

        &:not(:last-child) {
            border-right: 1px solid #fff;
        }
        &.loading:not(:last-child) {
            border-right: 1px solid #40aa93;
        }
        & > div:not(:last-child) {
             margin-right: 10px;
        }
        & > div:not(:first-child) {
             margin-top: -4px;
             margin-bottom: -4px;
        }
    }

    .nav-label {
        padding: 6px 8px;
        font-size: 0.8rem;
        border: 1px solid #fff;
        border-radius: 2px;
        background: transparent;
        color: #fff;
        display: flex;
        width: 85px;
        text-decoration: none;

        &:hover {
            background: #fff;
            color: #009978;
        }
    }

    .badge {
        background-color: #cc0000;
        display: block;
        color: #fff;
        height: calc(0.8rem + 3px);
        font-size: 0.5rem;
        border-radius: 7px;
        border: none;
        margin-left: 4px;
        margin-top: -1.5px;
        margin-bottom: -1.5px;
        line-height: 1.5;

        &.zero {
            background-color: #a0a7a8;
        }
        &.d1 {
            padding: 0.15rem 5px;
            border-radius: 50%;
        }
        &.d2 {
            padding: 0.15rem 5px;
            border-radius: 7px;
        }
        &.d3 {
            padding: 0.15rem 2px;
            border-radius: 7px;
        }
    }

    .skeleton {
        color: transparent;
        background-color: #40aa93;

        & * {
            visibility: hidden;
            opacity: 0;
        }
    }
}
</style>

<script>
import { ref, onMounted } from "vue";

const ENDPOINT = "/client/approval-information";

export default {
    props: {
        reportUnreceivedUrl: {
            type: String,
            required: true,
        },
        reportUnapprovedUrl: {
            type: String,
            required: true,
        },
        invoiceUnreceivedUrl: {
            type: String,
            required: true,
        },
        invoiceUnapprovedUrl: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const root = ref(null);
        const loading = ref(true);
        const year = ref('0000');
        const month = ref('00');
        const reportUnreceivedCount  = ref(0);
        const reportUnapprovedCount  = ref(0);
        const invoiceUnreceivedCount = ref(0);
        const invoiceUnapprovedCount = ref(0);

        const badge = (count) => {
            return [
                "badge",
                "d" + digit(count),
                count === 0 ? "zero" : "",
            ];
        };

        const digit = (num) => {
            return num.toString().length;;
        }

        const navigate = (url) => {
            window.location.href = url;
        }

        const splitTerm = (term) => {
            let strTerm = term.toString();
            return [
                strTerm.substring(0, 4),
                strTerm.substring(4, 6),
            ];
        }

        onMounted(() => {
            fetch(ENDPOINT)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.json()
                })
                .then((data) => {
                    [year.value, month.value]    = splitTerm(data.term);
                    reportUnreceivedCount.value  = data.reportUnreceivedCount;
                    reportUnapprovedCount.value  = data.reportUnapprovedCount;
                    invoiceUnreceivedCount.value = data.invoiceUnreceivedCount;
                    invoiceUnapprovedCount.value = data.invoiceUnapprovedCount;
                    loading.value = false;
                }).catch((_error) => {
                    if (root.value) {
                        root.value.parentNode.remove(); // 親要素ごと削除
                    }
                })
        });

        return {
            root,
            loading,
            year,
            month,
            reportUnreceivedCount,
            reportUnapprovedCount,
            invoiceUnreceivedCount,
            invoiceUnapprovedCount,
            navigate,
            badge,
        };
    },
};
</script>
